import React from "react";

const Banner = ({ title, subtitle }) => {
  return (
    <div className="relative min-h-[320px] md:min-h-[380px] lg:min-h-[420px] bg-[#f6fbfd] flex items-center justify-center overflow-hidden mt-6">
      {/* Large soft blue circle in the top-left */}
      <div className="absolute -top-32 -left-32 w-[420px] h-[420px] md:w-[520px] md:h-[520px] lg:w-[600px] lg:h-[600px] bg-blue-100 rounded-full" />

      {/* Main content */}
      <div className="relative z-10 w-full max-w-3xl mx-auto flex flex-col items-center justify-center text-center px-4">
        {subtitle && (
          <div className="mb-4 inline-block px-6 py-2 rounded-full bg-blue-100 text-blue-700 text-base font-medium tracking-wide">
            {subtitle}
          </div>
        )}
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-4 leading-tight">
          {title}
        </h1>
        {/* Decorative line */}
        <div className="h-1 w-24 bg-blue-300 rounded-full mx-auto mb-2" />
      </div>
    </div>
  );
};

export default Banner;
